import { PORTALS } from "../../../utils/portalTypes";
import PortalLoginPage from "../Auth/PortalLoginPage";

export default function ClinicLogin() {
  return <PortalLoginPage portal={PORTALS.admin} />;
}
